import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Trophy, Plus, Users, Check } from 'lucide-react';
import BottomSheet from '../sheets/BottomSheet';
import { useUserLeagues } from '../../hooks/useUserLeagues';

export default function LeagueSwitcherSheet({ open, onClose }) {
  const { leagueId } = useParams();
  const navigate = useNavigate();
  const { leagues, loading } = useUserLeagues();

  const go = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <BottomSheet open={open} onClose={onClose} title="Your leagues" anchor="top">
      {loading ? (
        <p style={{ fontSize: 15, color: 'var(--color-text-muted)', margin: '16px 0' }}>Loading...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
          {leagues.map((league) => {
            const isCurrent = league.id === leagueId;
            return (
              <button
                key={league.id}
                onClick={() => go(`/${league.id}/league`)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '12px 8px', minHeight: 44,
                  border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left',
                  borderRadius: 12,
                  WebkitTapHighlightColor: 'transparent',
                }}
              >
                <div style={{
                  width: 36, height: 36, borderRadius: 10, backgroundColor: 'var(--color-brand)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <Trophy size={16} color="#fff" />
                </div>
                <span style={{ flex: 1, fontSize: 15, fontWeight: 600, color: 'var(--color-text-strong)' }}>
                  {league.name || 'Unnamed league'}
                </span>
                {isCurrent && <Check size={18} color="var(--color-brand)" />}
              </button>
            );
          })}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, borderTop: '1px solid var(--color-bg-subtle)', paddingTop: 12 }}>
        <button
          onClick={() => go('/create-league')}
          style={{
            display: 'flex', alignItems: 'center', gap: 10, minHeight: 44,
            padding: '10px 8px', border: 'none', background: 'none', cursor: 'pointer',
            color: 'var(--color-brand)', fontSize: 15, fontWeight: 600, textAlign: 'left',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          <Plus size={18} /> Create a league
        </button>
        <button
          onClick={() => go('/join-league')}
          style={{
            display: 'flex', alignItems: 'center', gap: 10, minHeight: 44,
            padding: '10px 8px', border: 'none', background: 'none', cursor: 'pointer',
            color: 'var(--color-brand)', fontSize: 15, fontWeight: 600, textAlign: 'left',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          <Users size={18} /> Join a league
        </button>
      </div>
    </BottomSheet>
  );
}
